<template>
  <dd class="rew19_visibleOp" style="display: block;">
    <ul class="rew19_transition_table">
      <li>
        <em class="with_type1">생년월일</em>
        <div class="rew19_form_full">
          <input v-model.trim="viewData.card.birth" ref="birth"
            @keypress="numberKeyPress($event)"
            @keyup="keyUpToNumber($event, 'cardNum1')"                   
            maxlength="6"                  
            title="생년월일 입력" type="tel" class="autoFocus rew19_inputTxt_t1" 
            placeholder="주민등록번호 앞 6자리"/>
        </div>
      </li>
      <li>
        <em class="with_type1">카드번호</em>
        <div class="phone_type">
          <div class="rew19_form_full">
            <input v-model.trim="viewData.card.cardNums[0]" ref="cardNum1"
              @keypress="numberKeyPress($event)"
              @keyup="keyUpToNumber($event, 'cardNum2')"
              @keydown="keyDown($event, 0)"
              title="카드번호 입력" type="tel" maxlength="4"
              class="autoFocus onlynum rew19_inputTxt_t1" placeholder=""/>
          </div>
          <div class="rew19_form_full">
            <input v-model.trim="viewData.card.cardNums[1]" ref="cardNum2"
              @keypress="numberKeyPress($event)"
              @keyup="keyUpToNumber($event, 'cardNum3')"
              @keydown="keyDown($event, 1)"
              title="카드번호 입력" type="password" maxlength="4"
              class="autoFocus onlynum rew19_inputTxt_t1" placeholder=""/>
          </div>
          <div class="rew19_form_full">
            <input v-model.trim="viewData.card.cardNums[2]" ref="cardNum3"
              @keypress="numberKeyPress($event)"
              @keyup="keyUpToNumber($event, 'cardNum4')"
              @keydown="keyDown($event, 2)"
              title="카드번호 입력" type="password" maxlength="4"
              class="autoFocus onlynum rew19_inputTxt_t1" placeholder=""/>
          </div>
          <div class="rew19_form_full">
            <input v-model.trim="viewData.card.cardNums[3]" ref="cardNum4"
              @keypress="numberKeyPress($event)"
              @keyup="keyUpToNumber($event, 'expMM')"
              @keydown="keyDown($event, 3)"
              title="카드번호 입력" type="tel" maxlength="4"
              class="autoFocus onlynum rew19_inputTxt_t1" placeholder=""/>
          </div>
        </div>
      </li>
      <li class="with_type1"><span class="rew19_infoStar">사용불가 카드 : 외국계 카드, 법인카드</span></li>
      <li>
        <em class="with_type1">유효기간</em>
        <div class="phone_type limit">
          <div class="rew19_form_full">
            <input v-model.trim="viewData.card.expMM" ref="expMM"
              @keypress="numberKeyPress($event)"
              @keyup="keyUpToNumber($event, 'expYY')"
              title="유효기간 입력" type="tel" maxlength="2"
              class="autoFocus onlynum rew19_inputTxt_t1" placeholder="MM"/>
          </div>
          <div class="rew19_form_full">
            <input v-model.trim="viewData.card.expYY" ref="expYY"
              @keypress="numberKeyPress($event)"
              @keyup="keyUpToNumber($event, 'pwd')"
              title="유효기간 입력" type="tel" maxlength="2"
              class="autoFocus onlynum rew19_inputTxt_t1" placeholder="YY"/>
          </div>
        </div>
      </li>
      <li>
        <em class="with_type1">카드 비밀번호</em>
        <div class="phone_type limit">
          <div class="rew19_form_full">
            <input v-model.trim="viewData.card.pwd" ref="pwd"
              @keypress="numberKeyPress($event)"
              @keyup="keyUpToNumber($event)"
              title="카드 비밀번호 입력" type="password" maxlength="2"
              class="autoFocus onlynum rew19_inputTxt_t1" placeholder=""/>
          </div>
          <div class="txt_type">
              ** (앞자리 2자리)
          </div>
        </div>
      </li>
      <li v-if="showInstMonth">
        <em class="with_type1">할부개월</em>
        <div class="rew19_form_full limit">
          <span class="rew19_form_full">
            <select 
              v-model="viewData.card.instMonth"
              ref="instMonth"
              class="rew19_select_t1">
              <option value="00" selected>일시불</option>
              <option value="02">2개월</option>
              <option value="03">3개월</option>
              <option value="04">4개월</option>
              <option value="05">5개월</option>
              <option value="06">6개월</option>
              <option value="07">7개월</option>
              <option value="08">8개월</option>
              <option value="09">9개월</option>
              <option value="10">10개월</option>
              <option value="11">11개월</option>
              <option value="12">12개월</option>
            </select>
          </span>
        </div>
      </li>
      <li v-if="showInstMonth"
        class="with_type1">
        <span class="rew19_infoStar">체크카드는 할부를 지원하지 않습니다</span>
      </li>      
    </ul>
    <div v-if="showCardTerm"
      class="rew19_wrapCheck_t1 rew19_wrapixform">
      <input v-model="viewData.card.useAgree" ref="useAgree"
        type="checkbox" class="rew19_fakeCheck_t1" :id="'payment-card-use-agree'+checkTermIdNum"/>
      <label :for="'payment-card-use-agree'+checkTermIdNum">신용카드 사용동의</label>
      <a class="rew19_btn_T1 size_normal" @click="onClickShowCardAgree">내용보기</a>
    </div>

    <slot name="footer"></slot>
  </dd>
</template>
<script>
import * as ErrMsg from "@/utils/error_msg";
import * as Common from "@/utils/common";

const INIT_VIEW_DATA = {
  card :{
    birth : null,
    cardNums : [null, null, null, null],
    expMM : null,
    expYY : null,
    pwd : null,
    instMonth : "00",

    useTerm : '',
    useAgree : false,
    isCheckCard : false,
  }
}

export default {
  name: 'CardInfo',
  components: {  },
  props: {
    //신용카드 동의 사용여부
    showCardTerm : {
      type: Boolean,
      default: false
    },
    //할부개월 사용여부
    showInstMonth : {
      type: Boolean,
      default: false
    },
    checkTermIdNum : {
      type: String,
      default: "1"
    }   
  },
  data() {
    return {   
      viewData : {...INIT_VIEW_DATA},
    }
  },
  mounted() {
    let _this = this;
  },  
  methods :{
    /**
     * Local 
     */
    initData : function(data){
      let _this = this;
      
      //UI 초기화
      _this.viewData ={
        ...INIT_VIEW_DATA,
        card : {
          ...INIT_VIEW_DATA.card,
          ...data.card
        }
      };

      let cardNums = data.card && data.card.cardnumber ? 
        Common.getArrayForCardNumber(data.card.cardnumber) : [null, null, null, null];

      _this.viewData.card.cardNums = [...cardNums];      
    },

    //신용카드 사용동의
    onClickShowCardAgree(){
      let _this = this;

      let termPath = _this.viewData.card.useTerm;

      _this.$showLoading();
      _this.$http.get(termPath).then(res=>{
        _this.$dialogs.alert(res.data, {title: "신용카드 사용동의"}).then(res => {

        });
      }).catch((err)=>{        
        console.error(err);

        _this.$dialogs.alert(ErrMsg.COMM_UNKNOWN_MESSAGE, {title: ErrMsg.COMM_ERROR_TITLE})
        .then(res => {});

      }).finally(()=>{        
        _this.$hideLoading();
      });
    },

    //카드 결제 정보 검증
    validateCard(){
      let _this = this;

      let cardInfo = _this.viewData.card;
      let rexExOnlyNum = /^[0-9]*$/;
      let chVal = "";

      //생년월일
      chVal = cardInfo.birth;
      if(!chVal || chVal.trim() == ""){
        _this.$dialogs.alert("생년월일 입력해 주십시오.")
        .then(res => {
          _this.$refs.birth.focus();
        });   
        return false;
      }

      let regExBirth = /^\d{2}(0[0-9]|1[0-2])(0[1-9]|[1-2][0-9]|3[0-1])$/;
      if(!regExBirth.test(chVal)){
        _this.$dialogs.alert("생년월일 6자리 숫자로 입력해 주십시오.")
        .then(res => {
          _this.$refs.birth.focus();
        });   
        return false;
      }

      //카드확인
      let errMsgCardNum = [
        "카드번호 첫번째자리 입력하시기 바랍니다.",
        "카드번호 두번째자리 입력하시기 바랍니다.",
        "카드번호 세번째자리 입력하시기 바랍니다.",
        "카드번호 네번째자리 입력하시기 바랍니다.",
      ];

      let errMsgCardNumNumber = [
        "카드번호 첫번째자리 숫자만 입력하시기 바랍니다.",
        "카드번호 두번째자리 숫자만 입력하시기 바랍니다.",
        "카드번호 세번째자리 숫자만 입력하시기 바랍니다.",
        "카드번호 네번째자리 숫자만 입력하시기 바랍니다."
      ];

      let cardnumber = "";
      for (let idx=0; idx < cardInfo.cardNums.length; idx++){        
        let cardNum = cardInfo.cardNums[idx];

        if(!cardNum || cardNum.trim() == ""){
          _this.$dialogs.alert(errMsgCardNum[idx])
          .then(res => {
             _this.$refs["cardNum"+(idx+1)].focus();
          });   
          return false;
        }

        if(!rexExOnlyNum.test(cardNum)){
          _this.$dialogs.alert(errMsgCardNumNumber[idx])
          .then(res => {
            _this.$refs["cardNum"+(idx+1)].focus();
          });   
          return false;
        }

        cardnumber += (""+cardNum);
      }

      if(cardnumber.length < 14){
        _this.$dialogs.alert("카드번호 14자리 이상 입력하시기 바랍니다.")
        .then(res => {
          _this.$refs["cardNum1"].focus();
        });   
        return false;
      }
      cardInfo.cardnumber = cardnumber;

      //유효기간 MM
      chVal = cardInfo.expMM;
      if(!chVal || chVal.trim() == ""){
        _this.$dialogs.alert("카드 유효기간 월을 입력해 주세요.")
        .then(res => {
          _this.$refs.expMM.focus();
        });   
        return false;
      }

      if(!rexExOnlyNum.test(chVal)){
        _this.$dialogs.alert("카드 유효기간 월을 숫자로만 입력하시기 바랍니다.")
        .then(res => {
          _this.$refs.expMM.focus();
        });   
        return false;
      }

      //유효기간 YY
      chVal = cardInfo.expYY;
      if(!chVal || chVal.trim() == ""){
        _this.$dialogs.alert("카드 유효기간 년도를 선택해 주세요.")
        .then(res => {
          _this.$refs.expYY.focus();
        });   
        return false;
      }

      if(!rexExOnlyNum.test(chVal)){
        _this.$dialogs.alert("카드 유효기간 년도를 숫자로만 입력하시기 바랍니다.")
        .then(res => {
          _this.$refs.expYY.focus();
        });   
        return false;
      }

      //비밀번호 2자리
      chVal = cardInfo.pwd;
      if(!chVal || chVal.trim() == ""){
        _this.$dialogs.alert("카드 비밀번호를 입력하시기 바랍니다.")
        .then(res => {
          _this.$refs.pwd.focus();
        });   
        return false;
      }

      if(chVal.length != 2){
        _this.$dialogs.alert("카드 비밀번호 숫자를 2자리 입력해주시기 바랍니다.")
        .then(res => {
          _this.$refs.pwd.focus();
        });   
        return false;
      }

      if(!rexExOnlyNum.test(chVal)){
        _this.$dialogs.alert("카드 비밀번호 숫자만 입력하시기 바랍니다.")
        .then(res => {
          _this.$refs.pwd.focus();
        });   
        return false;
      }

      // 카드 사용 동의
      if(_this.showCardTerm && !cardInfo.useAgree){
        _this.$dialogs.alert("신용카드 사용에 동의해 주세요.")
        .then(res => {
          _this.$refs.useAgree.focus();
        });   
        return false;
      }      

      return true;
      
    },
    
    //입력정보 리턴
    getCardInfo(){
      let _this = this;
      return _this.viewData.card;
    },

    /**
     * Util
     */
    numberKeyPress(evt) {
      evt = (evt) ? evt : window.event;
      var charCode = (evt.which) ? evt.which : evt.keyCode;
      if ((charCode > 31 && (charCode < 48 || charCode > 57)) && charCode !== 46) {
        evt.preventDefault();
      } else {
        return true;
      }
    },

    keyUpToNumber(evt, nextRef){
      let _this = this;
      evt = (evt) ? evt : window.event;
      evt.target.value = evt.target.value.replace(/[^0-9]/g, "");

      if(nextRef){        
        let maxLength = evt.target.maxLength;
        if(evt.target.value.length >= maxLength){
          _this.$refs[nextRef].focus();
        }
      }
    },

    keyDown(evt, target){
      let _this = this;
      evt = (evt) ? evt : window.event;
      var charCode = (evt.which) ? evt.which : evt.keyCode;
      if(charCode == 46 || charCode == 8){
        evt.target.value = '';
        _this.viewData.card.cardNums[target] = '';
      }
    },
  }
}
</script>
<style>
.rew19_visible_card{
   display: block; 
}

a.rew19_btn_T1, .rew19_fakeCheck_t1 label,.rew19_wrapRadio_t1 label{
  cursor: pointer;
}
</style>



// WEBPACK FOOTER //
// src/components/control/CardInfo.vue